export const LogoMark = ({ size = 30, className = "" }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
    <path d="M20 5C12.3 5 6 11.3 6 19v16h28V19C34 11.3 27.7 5 20 5Z" stroke="currentColor" strokeWidth="2" />
    <circle cx="20" cy="24.5" r="3" fill="currentColor" />
  </svg>
);
